export const OPEN_POSITION_FILTER_CONSTANTS = {
  LABELS: {
    FILTER: 'Filter',
    JOB_TITLE: 'Job Title',
    LOB: 'LOB',
    ID_T_LEADER: 'ID&T Leader',
    OPENED_DATE: 'Opened Date',
    DESIRED_START_DATE: 'Desired Start Date',
    LOCATION: 'Location',
    SELECT_VENDOR: 'Select Vendor (s)',
    STATUS: 'Status',
    RESET: 'Reset',
    APPLY: 'Apply',
    SAVE: 'Save'
  },
  
  BUTTON_TYPES: {
    PRIMARY: 'Primary',
    SECONDARY: 'Secondary'
  },
  
  BUTTON_SIZES: {
    SMALL: 'Small',
    MEDIUM: 'Medium',
    LARGE: 'Large'
  },
  
  FORM_IDS: {
    SINGLE_SELECT_JOBTITLE: 'single_select_jobtitle',
    SINGLE_SELECT_LOB: 'single_select_lob',
    SINGLE_SELECT_LEADER: 'single_select_leader',
    SINGLE_SELECT_LOCATION: 'single_select_location',
    SINGLE_SELECT_VENDOR: 'single_select_vendor',
    SINGLE_SELECT_STATUS: 'single_select_status'
  },
  
  ERROR_MESSAGES: {
    SAMPLE_ERROR: 'Sample error text',
    FILTER_CLEANUP: 'Error during filter cleanup:',
    INVALID_MONTH: 'Invalid month selected'
  },
  
  CSS_CLASSES: {
    PICKER_DATE: 'pickerDate',
    MDC_DIALOG_BUTTON: 'mdc-dialog__button'
  },
  
  ICONS: {
    FILTER_LIST: 'filter_list'
  },
  
  TIMEOUT_VALUES: {
    SHORT: 50,
    MEDIUM: 100,
    LONG: 500
  },
  
  STATUS_VALUES: {
    OPEN_LABEL: 'Open',
    OPEN_LOWER: 'open'
  },
  
  FIELD_NAMES: {
    JOB_TITLE: 'jobTitle',
    LOB_NAME: 'lobName',
    VENDOR_NAME: 'vendorName',
    DNT_LEADER_NAME: 'dntLeaderName',
    CREATED_DATE: 'createdDate',
    LOCATION: 'location',
    STATUS: 'status'
  }
} as const;
